/**
 * CutIcon/index.js
 * desc: content cut icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const CutIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="cut icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.cut.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M7.64 5.64C7.87 5.14 8 4.59 8 4c0-2.21-1.79-4-4-4S0 1.79 0 4s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L8 10l-2.36 2.36C5.14 12.13 4.59 12 4 12c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L10 12l7 7h3v-1L7.64 5.64zM4 6a2 2 0 11-.001-3.999A2 2 0 014 6zM2 16a2 2 0 103.999.001A2 2 0 002 16zm8-5.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM11 7l6-6h3v1l-7 7-2-2z"/></svg>
    </IconButton>
);


export default CutIcon;
